import { type ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
    return (
        <div className="flex items-center justify-between gap-3 border-b p-4">
            <div className="min-w-0 flex-1">
                <h2 className="text-xl font-bold sm:text-2xl">{title}</h2>
                {subtitle && <p className="text-muted-foreground text-sm sm:text-base">{subtitle}</p>}
            </div>
            {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
        </div>
    );
}
